import { ExpandLess } from '@mui/icons-material'
import {
  Box,
  Card, CardProps,
  Collapse,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { FC, useState } from 'react'

interface MapLegendProps {
  CardProps?: CardProps
}

export const MapLegend:FC<MapLegendProps> = ({CardProps = {}}) => {
  const {sx: cardSx, ...CardPropsRest} = CardProps
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <Card
      {...CardPropsRest}
      sx={{
        boxShadow: 'none',
        borderRadius: '12px',
        background: 'rgba(255, 255, 255, 0.9)',
        border: `1px solid ${theme.palette.grey[200]}`,
        width: isExpanded ? (isMobile ? '280px' : '300px') : 'auto',
        overflow: 'hidden',
        p: 2,
        ...cardSx
      }}
    >
      <Stack spacing={1.5}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          {!isExpanded && (
            <Box
              sx={{
                height: '24px',
                width: '24px',
                borderRadius: '4px',
                background: 'linear-gradient(90deg, #B3CDDD 0%, #00598E 100%)',
              }}
            />
          )}
          {isExpanded && (
            <Typography
              fontSize="14px"
              fontWeight={600}
              color="text.primary"
            >
              Violations count
            </Typography>
          )}
          <IconButton
            size="small"
            onClick={() => setIsExpanded(!isExpanded)}
            sx={{
              ml: isExpanded ? 'auto' : 0,
              marginRight: -1,
            }}
          >
            <ExpandLess
              sx={{
                transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease',
              }}
            />
          </IconButton>
        </Box>

        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <Stack spacing={0.5}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography
                fontSize="14px"
                fontWeight={400}
                color="text.secondary"
              >
                Less
              </Typography>
              <Typography
                fontSize="14px"
                fontWeight={400}
                color="text.secondary"
              >
                More
              </Typography>
            </Box>

            <Box
              sx={{
                height: '24px',
                width: '100%',
                borderRadius: '4px',
                background: 'linear-gradient(90deg, #B3CDDD 0%, #00598E 100%)',
              }}
            />
          </Stack>
        </Collapse>
      </Stack>
    </Card>
  )
}
